import gql from 'graphql-tag'

export const GET_CLIENT_QUERY = gql`
	query (
		$id: Int!
	) {
		getClient (
			data: {
				id: $id
			}
		) {
			id
			fullName
			telNumber
			email
			address
			banned
			createdAt
			image
			clientType
			type
			updatedAt
		}
	}
`

export const GET_CLIENTS_PAGINATION_QUERY = gql`
	query (
		$skip: Int!,
		$take: Int!,
		$orderBy: [OrderByInput!]
		$query: String
	) {
		getClients (
			data: {
				orderBy: $orderBy
				pagination: {
					skip: $skip
					take: $take
				}
				query: $query
			}
		) {
			hasMore
			total
			items {
				id
				fullName
				telNumber
				email
				banned
				image
				clientType
			}
		}
	}
`
